import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration, replayIntegration } from "@sentry/react"; // Correct imports
import App from "./App.jsx";
import "./index.css";
import 'react-toastify/dist/ReactToastify.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    browserTracingIntegration(),
    replayIntegration(),
  ],
  // tracesSampleRate: 1.0,
  // replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    "Failed prop type",
    "Invalid prop"
  ],
  // tracesSampleRate: 1.0,
  tracesSampleRate: 0.2,
  // replaysSessionSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
});

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
